import { render, staticRenderFns } from "./pd-shipping-convincer.vue?vue&type=template&id=3a7198d6&"
import script from "./pd-shipping-convincer.vue?vue&type=script&lang=js&"
export * from "./pd-shipping-convincer.vue?vue&type=script&lang=js&"
import style0 from "./pd-shipping-convincer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShippingTimer: require('/opt/build/repo/storefront/components/legacy/global/shipping-timer.vue').default})
